import request from '@/utils/request'

// crm 新建線索
export function crmLeadsSave(data) {
  return request({
    url: 'crm/leads/save',
    method: 'post',
    data: data
  })
}

// crm 列表
export function crmLeadsIndex(data) {
  return request({
    url: 'crm/leads/index',
    method: 'post',
    data: data
  })
}

// 刪除
export function crmLeadsDelete(data) {
  return request({
    url: 'crm/leads/delete',
    method: 'post',
    data: data
  })
}

// crm 更新
export function crmLeadsUpdate(data) {
  return request({
    url: 'crm/leads/update',
    method: 'post',
    data: data
  })
}

// crm 詳情
export function crmLeadsRead(data) {
  return request({
    url: 'crm/leads/read',
    method: 'post',
    data: data
  })
}

/**
 * 線索轉移
 * @param {*} data
 * leads_id 	線索陣列
 * owner_user_id 	變更負責人
 * is_remove 1移出，2轉為團隊成員
 * type 許可權 1只讀2讀寫
 */
export function crmLeadsTransfer(data) {
  return request({
    url: 'crm/leads/transfer',
    method: 'post',
    data: data
  })
}

/**
 * 線索轉換為客戶
 * @param {*} data
 * leads_id 	線索陣列
 */
export function crmLeadsTransform(data) {
  return request({
    url: 'crm/leads/transform',
    method: 'post',
    data: data
  })
}

/**
 * 線索導出
 * @param {*} data
 *
 */
export function crmLeadsExcelExport(data) {
  return request({
    url: 'crm/leads/excelExport',
    method: 'post',
    data: data,
    responseType: 'blob',
    timeout: 600000
  })
}

/**
 * 線索匯入
 * @param {*} data
 *
 */
export function crmLeadsExcelImport(data) {
  var param = new FormData()
  Object.keys(data).forEach(key => {
    param.append(key, data[key])
  })
  return request({
    url: 'crm/leads/excelImport',
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000
  })
}

/**
 * 線索匯入模板下載
 * @param {*} data
 *
 */
export const crmLeadsExcelDownloadURL = 'crm/leads/excelDownload'

/**
 * 線索標記跟進
 * @param {*} data
 * id 客戶IDs
 */
export function crmLeadsSetFollowAPI(data) {
  return request({
    url: 'crm/leads/setFollow',
    method: 'post',
    data: data
  })
}
